import { Col, Divider, Modal, Row, Select, Space, Tooltip } from "antd"
import Splitter from "antd/es/splitter/Splitter"
import { saveAs } from "file-saver"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { FloatActionWrapper } from "src/components/FloatAction/styles"
import InputCustom from "src/components/Input/InputCustom"
import Delete from "src/components/Modal/Delete"
import Button from "src/components/MyButton/Button"
import SelectCustom from "src/components/Select/SelectCustom"
import TableCustom from "src/components/Table/CustomTable"
import {
  MainTableData,
  MainTableHeader,
  SubTableData,
  SubTableHeader,
} from "src/components/Table/CustomTable/styled"
import {
  COLOR_STATUS,
  hideOnSinglePage,
  SYSTEM_KEY,
} from "src/constants/constants"
import { getListComboByKey, renderButtonCircle } from "src/lib/utils"
import AccountService from "src/services/AccountService"
import ContactsService from "src/services/Contacts"
import MemberService from "src/services/MemberService"
import DetailMember from "./components/DetailMember"
import ListOrganization from "./components/ListOrganization"
import ModalInsertOrganization from "./components/ModalInsertOrganization"
import { UnitContactStyled } from "./styled"

const lstMemberType = [
  {
    id: 0,
    title: "Tất cả",
  },
  {
    id: 1,
    title: "Cá nhân",
  },
  {
    id: 2,
    title: "Tổ chức",
  },
]

const { Option } = Select
const OrganizationContact = () => {
  const { listSystemKey } = useSelector(state => state.appGlobal)
  const [organizationSelect, setOrganizationSelect] = useState()
  const [pagination, setPagination] = useState({
    PageSize: 15,
    CurrentPage: 1,
  })
  const [openModalDetail, setOpenModalDetail] = useState(false)
  const [detailMember, setDetailMember] = useState()
  const [textSearch, setTextSearch] = useState("")
  const [loading, setLoading] = useState(false)
  const [listData, setListData] = useState()
  const [listSelect, setListSelect] = useState([])
  const [openModalDelete, setOpenModalDelete] = useState(undefined)
  const [isEdit, setIsEdit] = useState(undefined)
  const [openInsert, setOpenInsert] = useState(false)
  const [total, setTotal] = useState(0)

  useEffect(() => {
    if (pagination) {
      if (organizationSelect?.key === "UNKNOWN_MEMBER") {
        getListUnknownMember()
      } else {
        getList()
      }
    }
  }, [pagination, organizationSelect])

  const getList = async () => {
    try {
      setLoading(true)

      const res = await AccountService.getListMemberByAccount({
        ...pagination,
        textSearch,
        AccountID:
          organizationSelect?.key || "00000000-0000-0000-0000-000000000000",
      })
      if (res?.isError) return
      setListData(res?.Object?.lstMemberVM)
      setTotal(res?.Object?.total)
    } finally {
      setLoading(false)
    }
  }

  const getListUnknownMember = async () => {
    try {
      setLoading(true)
      const res = await AccountService.getAllNoneAccountUser({
        ...pagination,
        textSearch,
      })
      if (res?.isError) return
      setListData(res?.Object?.ListData)
      setTotal(res?.Object?.TotalCount)
    } finally {
      setLoading(false)
    }
  }

  const handleExport = () => {
    setLoading(true)
    ContactsService.exportUser({
      Status: pagination.Status,
      AccountType: pagination.AccountType,
      textSearch,
      AccountID:
        listSelect.length > 0
          ? listSelect.map(i => i.AccountID).toString()
          : undefined,
    })
      .then(res => {
        if (res.isError) return
        saveAs(res, "Danh_sach_don_vi.xlsx")
      })
      .finally(() => setLoading(false))
  }

  const handleDeleteMany = async arrUserId => {
    try {
      const res = await AccountService.deleteMember(arrUserId)
      if (res?.isError) return
    } catch (error) {
      console.log("error: ", error)
    } finally {
      // Gọi đúng API tương ứng sau khi xóa
      if (organizationSelect?.key === "UNKNOWN_MEMBER") {
        getListUnknownMember()
      } else {
        getList()
      }
    }
  }

  const handleEdit = async (userId, memberType, record) => {
    setLoading(true)
    try {
      const res = await MemberService.getMemberDetail({
        memberId: userId,
        memberType: memberType,
      })
      if (!res?.isError) {
        res.Object.UserID = userId
        // res.Object.AccountID = record.AccountID
        res.Object.UserName = record.UserName
        res.Object.PositionID = record.PositionID

        setIsEdit(res?.Object)
        setOpenInsert(true)
      }
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    {
      title: (
        <>
          <MainTableHeader>Họ và tên</MainTableHeader>
          <SubTableHeader>Tên tài khoản</SubTableHeader>
        </>
      ),
      dataIndex: "UserName",
      key: "UserName",
      align: "center",
      render: (val, record) => (
        <>
          <MainTableData>{record?.FullName}</MainTableData>
          <SubTableData>{val}</SubTableData>
        </>
      ),
    },
    {
      title: (
        <>
          <MainTableHeader>Email</MainTableHeader>
          <SubTableHeader>Số điện thoại</SubTableHeader>
        </>
      ),
      dataIndex: "PhoneNumber",
      key: "PhoneNumber",
      align: "center",
      render: (val, record) => (
        <>
          <MainTableData>{record?.Email}</MainTableData>
          <SubTableData>{val}</SubTableData>
        </>
      ),
    },
    {
      title: "Kiểu hội viên",
      dataIndex: "MemberType",
      key: "MemberType",
      align: "center",
      render: (val, record) =>
        record?.MemberType === 1 ? "Cá nhân" : "Tổ chức",
    },
    {
      title: "Đơn vị",
      dataIndex: "AccountName",
      key: "AccountName",
      align: "center",
      render: val => (
        <Tooltip title={val}>
          <div className="max-line2">{val ? val : "-"}</div>
        </Tooltip>
      ),
    },
    {
      title: "Trạng thái",
      dataIndex: "Status",
      key: `Status`,
      align: "center",
      width: 140,
      render: (val, record) => (
        <div>
          <div
            className="text-center fw-700"
            style={
              val === 1
                ? { color: COLOR_STATUS.active }
                : { color: COLOR_STATUS.inactive }
            }
          >
            {val === 1 ? "Kích hoạt" : "Vô hiệu"}
          </div>
          <FloatActionWrapper size="small" className="float-action__wrapper">
            {renderButtonCircle(
              "Chỉnh sửa",
              "edit",
              e => {
                e.stopPropagation()
                handleEdit(record.UserID, record.MemberType, record)
              },
              true,
            )}
          </FloatActionWrapper>
        </div>
      ),
    },
  ]

  const getDetailMember = async (memberId, memberType) => {
    try {
      setLoading(true)
      const res = await MemberService.getMemberDetail({
        memberId: memberId,
        memberType: memberType,
      })
      if (res?.isError) return

      setDetailMember(res?.Object)
    } finally {
      setLoading(false)
    }
  }

  const handleRowClick = record => {
    setOpenModalDetail(true)
    getDetailMember(record?.UserID, record?.MemberType)
  }

  return (
    <UnitContactStyled>
      <Row gutter={[16, 16]}>
        <Col md={10} xs={24}>
          <InputCustom
            type="search"
            allowClear
            label="Nhập tên, SĐT đơn vị"
            onSearch={() => setPagination(pre => ({ ...pre, CurrentPage: 1 }))}
            onChange={e => setTextSearch(e?.target?.value)}
          />
        </Col>
        <Col lg={7} xs={24}>
          <SelectCustom
            label="Trạng thái"
            value={pagination.Status}
            onChange={Status => {
              setPagination(pre => ({ ...pre, Status, CurrentPage: 1 }))
            }}
          >
            {getListComboByKey(SYSTEM_KEY?.STATUS, listSystemKey)?.map(i => (
              <Option key={+i.CodeValue} value={+i.CodeValue}>
                {i?.Description}
              </Option>
            ))}
          </SelectCustom>
        </Col>
        <Col lg={7} xs={24}>
          <SelectCustom
            label="Nhóm đơn vị"
            defaultValue={0}
            onChange={MemberType => {
              setPagination(pre => ({ ...pre, MemberType, CurrentPage: 1 }))
            }}
          >
            {lstMemberType?.map(i => (
              <Option key={i.id} value={i.id}>
                {i?.title}
              </Option>
            ))}
          </SelectCustom>
        </Col>
      </Row>

      <Divider className="mv-16" />
      <Row gutter={16}>
        <Splitter>
          <Splitter.Panel defaultSize="22%" min="15%" max="45%">
            <Col style={{ width: 750 }}>
              <ListOrganization
                organizationSelect={organizationSelect}
                setOrganizationSelect={setOrganizationSelect}
              />
            </Col>
          </Splitter.Panel>
          <Splitter.Panel>
            <Col flex="auto">
              <Row className="pt-0 pb-16 mb-16 title-type-1 justify-content-space-between align-items-center">
                <div style={{ fontSize: 24 }}>
                  {organizationSelect?.key === "UNKNOWN_MEMBER"
                    ? "Danh sách hội viên không có đơn vị"
                    : "Danh sách hội viên"}{" "}
                  ({total}) :
                </div>
                <Space>
                  {listSelect.length > 0 && (
                    <Button
                      btnType="primary"
                      className="btn-hover-shadow"
                      onClick={() =>
                        setOpenModalDelete({
                          deleteAll: true,
                          UsersID: listSelect.map(i => i?.UserID),
                        })
                      }
                    >
                      Xóa nhiều
                    </Button>
                  )}
                  <Button
                    btnType="third"
                    className="btn-hover-shadow"
                    onClick={handleExport}
                  >
                    Xuất Excel
                  </Button>
                </Space>
              </Row>
              <TableCustom
                isPrimary
                rowSelection={{
                  selectedRowKeys: listSelect?.map(i => i?.UserID),
                  onChange: (listKey, listItems) => {
                    setListSelect(listItems)
                  },
                  preserveSelectedRowKeys: true,
                }}
                onRow={record => ({
                  onClick: event => {
                    const target = event.target
                    if (
                      target instanceof HTMLElement &&
                      target.closest(".ant-table-selection-column")
                    ) {
                      return
                    }
                    handleRowClick(record)
                  },
                })}
                dataSource={listData}
                columns={columns}
                sticky={{ offsetHeader: 52 }}
                loading={loading}
                textEmpty="Không có hội viên nào!"
                pagination={{
                  hideOnSinglePage: total <= hideOnSinglePage,
                  current: pagination?.CurrentPage,
                  pageSize: pagination?.PageSize,
                  responsive: true,
                  total: total,
                  locale: { items_per_page: "" },
                  showSizeChanger: total > 10,
                  onChange: (CurrentPage, PageSize) => {
                    setPagination({
                      ...pagination,
                      CurrentPage,
                      PageSize,
                    })
                  },
                }}
                rowKey="UserID"
              />

              {openModalDetail && (
                <Modal
                  style={{ marginTop: 100 }}
                  width={900}
                  title="Chi tiết hội viên"
                  closable={{ "aria-label": "Custom Close Button" }}
                  open={openModalDetail}
                  onOk={() => setOpenModalDetail(false)}
                  onCancel={() => setOpenModalDetail(false)}
                  footer={null}
                  bodyStyle={{ maxHeight: 700, overflowY: "auto" }}
                >
                  <DetailMember detailMember={detailMember} />
                </Modal>
              )}
            </Col>
          </Splitter.Panel>
        </Splitter>
      </Row>

      {openInsert && (
        <ModalInsertOrganization
          openInsert={openInsert}
          onCancel={() => setOpenInsert(false)}
          onOk={() => setOpenInsert(false)}
          initialData={isEdit}
          getList={() => {
            if (organizationSelect?.key === "UNKNOWN_MEMBER") {
              getListUnknownMember()
            } else {
              getList()
            }
          }}
        />
      )}

      {openModalDelete && (
        <Delete
          isOpen={!!openModalDelete}
          content={{
            title: (
              <div className="text-center fw-600" style={{ fontSize: 16 }}>
                {`Bạn có chắc chắn muốn xóa tất cả hội viên đã chọn không?`}
              </div>
            ),
          }}
          onOk={() => {
            handleDeleteMany(openModalDelete.UsersID)
            setOpenModalDelete(undefined)
            setListSelect([])
          }}
          onCancel={() => setOpenModalDelete(undefined)}
        />
      )}
    </UnitContactStyled>
  )
}

export default OrganizationContact
